import { CustomFlowbiteTheme } from 'flowbite-react'

export const detailTabsTheme: CustomFlowbiteTheme['tabs'] = {
  tablist: {
    variant: {
      underline:
        'hidden lg:flex bg-white sticky top-[77px] pt-4 flex-wrap -mb-px border-b border-gray-200 z-20',
    },
    tabitem: {
      base: 'flex items-center justify-center p-4 rounded-t-lg text-sm font-medium first:ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 focus:outline-none',
      variant: {
        underline: {
          base: 'rounded-t-lg hover:border-gray-900',
          active: {
            on: 'text-gray-800 rounded-t-lg border-b-2 border-gray-900 active',
            off: 'border-b-2 border-transparent text-gray-500 hover:border-gray-900 hover:text-gray-800',
          },
        },
      },
    },
  },
}
